import {Routes} from '@angular/router';

import {AboutRoutes} from './about/about.routes';
import {HomeRoutes} from './home/home.routes';
import {JobsRoutes} from './jobs/jobs.routes';
import {JobDetailsRoutes} from "./jobDetails/jobDetails.routes";
import {RequestRoutes} from './request/request.routes';
import {SigningRoutes} from "./signing/signing.routes";
import {NewJobRoutes} from "./newJob/newJob.routes";
import {AccountRoutes} from "./account/account.routes";
import {UpgradeRoutes} from "./upgrade/upgrade.routes";
import {SubscriptionRoutes} from "./subscription/subscription.routes";
import {DeleteConfirmRoutes} from "./deleteConfirm/delete-confirm.routes";
import {PaymentRoutes} from "./payment/payment.routes";
import {ResultRoutes} from "./result/result.routes";
import {CombineRoutes} from "./combine/combine.routes";
import {SharingRoutes} from "./sharing/sharing.routes";
import {ViewRoutes} from "./view/view.routes";
import {ValidateRoutes} from "./validate/validate.routes";
import {PrepareRoutes} from "./prepare/prepare.routes";
import {PrepareSelfRoutes} from "./prepareSelf/prepare-self.routes";
import {DocRequestRoutes} from "./docRequest/docRequest.routes";
import {FormDesignerRoutes} from "./formDesigner/form-designer.routes";
import {MultiSigningRoutes} from "./multisigning/multisigning.routes";
import {FromDriveRoutes} from "./fromDrive/fromDrive.routes";
import {SigningCadesRoutes} from "./signingCades/signing-cades.routes";
import {UppyCallbackComponent} from "./uppy-callback/uppy-callback.component";

export const routes: Routes = [
  { path: 'uppy-callback', component: UppyCallbackComponent },
  { path: 'uppy-callback-proxy', component: UppyCallbackComponent },
  ...HomeRoutes,
  ...AboutRoutes,
  ...JobsRoutes,
  ...JobDetailsRoutes,
  ...RequestRoutes,
  ...SigningRoutes,
  ...SigningCadesRoutes,
  ...NewJobRoutes,
  ...DeleteConfirmRoutes,
  ...AccountRoutes,
  ...UpgradeRoutes,
  ...SubscriptionRoutes,
  ...PaymentRoutes,
  ...ResultRoutes,
  ...CombineRoutes,
  ...SharingRoutes,
  ...ViewRoutes,
  ...ValidateRoutes,
  ...PrepareRoutes,
  ...PrepareSelfRoutes,
  ...FormDesignerRoutes,
  ...DocRequestRoutes,
  ...MultiSigningRoutes,
  ...FromDriveRoutes,

];
